import { Modal } from '../../common/Modal';
import CorvinThinking from '../../corvin/CorvinThinking';

// Shown while a quick diagnosis runs (~45s of Claude). Without it the
// Diagnose button looked dead, and each extra click was another billed call.
// No close control: the request can't be cancelled, and closing would only
// invite a second click.
export default function DiagnosisProgressModal({ open, job }) {
  if (!open) return null;
  return (
    <Modal
      isOpen
      onClose={() => {}}
      title={job?.job_number ? `Diagnosing ${job.job_number}` : 'Diagnosing'}
      size="sm"
      showCloseButton={false}
      closeOnEscape={false}
      closeOnOverlayClick={false}
    >
      <CorvinThinking label="Corvin is diagnosing this. It usually takes under a minute." />
    </Modal>
  );
}
